import React from 'react';
import List from 'components/list/List';
import { Surgerie } from 'types/surgerie';
import ReportSurgerieItemModule from './ReportSurgerieItemModule';
import ReportSurgerieMenu from '../menu/ReportSurgerieMenu';
import { useReportSurgerie } from '../../hooks/useReportSurgerie';

interface ReportSurgerieListModuleProps {
  surgeries: Surgerie[];
}

const ReportSurgerieListModule: React.FC<ReportSurgerieListModuleProps> = ({ surgeries }) => {
  const { anchorEl } = useReportSurgerie();

  return (
    <>
      {anchorEl && <ReportSurgerieMenu anchorEl={anchorEl} />}
      <List>
        {surgeries.map(surgerie => (
          <ReportSurgerieItemModule key={surgerie.id} surgerie={surgerie} />
        ))}
      </List>
    </>
  );
};

export default ReportSurgerieListModule;
